import type { ComponentProps } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

export const DesignToolsIcon = forwardRef<SVGSVGElement, Props>(
	(props, ref) => (
		<svg
			width="1em"
			height="1em"
			viewBox="0 0 16 16"
			xmlns="http://www.w3.org/2000/svg"
			ref={ref}
			{...props}
		>
			<path
				fill="currentColor"
				d="M4.28504 1.68956L14.563 11.9676C14.7583 12.1628 14.7583 12.4794 14.563 12.6747L12.1315 15.1062C11.9363 15.3014 11.6197 15.3014 11.4244 15.1062L9.79971 13.4813L10.9659 12.3154L11.0404 12.2301C11.2886 11.9039 11.2638 11.4363 10.9659 11.1384C10.6409 10.8134 10.1139 10.8134 9.78891 11.1384L8.62271 12.3043L7.57971 11.2613L8.74656 10.096L8.82104 10.0108C9.06931 9.68457 9.04449 9.21695 8.74656 8.91903C8.42155 8.59401 7.8946 8.59401 7.56958 8.91903L6.40271 10.0843L5.36071 9.04226L6.52723 7.87668L6.60172 7.79145C6.84999 7.46524 6.82516 6.99763 6.52723 6.6997C6.20222 6.37469 5.67527 6.37469 5.35026 6.6997L4.18371 7.86526L3.14171 6.82326L4.30791 5.65735L4.38239 5.57213C4.63067 5.24592 4.60584 4.77831 4.30791 4.48038C3.9829 4.15537 3.45595 4.15537 3.13094 4.48038L1.96471 5.64626L1.14645 4.82816C0.951183 4.6329 0.951183 4.31631 1.14645 4.12105L3.57794 1.68956C3.7732 1.4943 4.08978 1.4943 4.28504 1.68956ZM4.09282 10.1283L6.49782 12.5333L5.19241 13.8774C4.5533 14.5164 1.94514 15.2392 1.48476 15.1152L1.43869 15.0953C1.1636 14.8986 2.21596 12.1721 2.88876 11.376L2.96461 11.293L4.09282 10.1283ZM14.5234 1.8645C15.15 2.491 15.1868 3.48385 14.634 4.15345L14.5234 4.27504L11.9108 6.96226L9.50182 4.55426L12.1126 1.8645C12.7783 1.19885 13.8577 1.19885 14.5234 1.8645Z"
			/>
		</svg>
	),
)
